<template>
<!-- 城市-汇付账户 企业信息页面 -->
    <el-dialog :visible.sync="show" width="70%" append-to-body :before-close="closeDialog" :close-on-click-modal="false">
        <div class="form-box" id="form-box">
            <el-form
                ref="form"
                :model="submit_data"
                label-width="260px"
                style="overflow-y: auto; width: 100%; height: 50vh; margin-top: 20px"
            >
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="银行卡户名:">
                            <el-input
                                v-model="submit_data.name"
                                :placeholder="submit_rules.name.placeholder"
                                style="width: 260px; margin-right: 5px"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="银行卡号:">
                            <el-input
                                v-model="submit_data.card_no"
                                :placeholder="submit_rules.card_no.placeholder"
                                style="width: 260px; margin-right: 5px"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="银行所在省:">
                            <el-select
                                clearable
                                filterable
                                v-model="submit_data.prov_id"
                                placeholder="请选择省"
                                style="width: 260px"
                                @visible-change="getDistrict('sheng')"
                            >
                                <el-option v-for="(item, index) in regProvIdArray" :key="index" :label="item.name" :value="item.adcode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="银行所在市:">
                            <el-select
                                @visible-change="getDistrict('shi')"
                                clearable
                                filterable
                                v-model="submit_data.area_id"
                                placeholder="请选择市"
                                style="width: 260px"
                            >
                                <el-option v-for="(item, index) in regAreaIdArray" :key="index" :label="item.name" :value="item.adcode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="银行号:">
                            <el-select
                                filterable
                                remote
                                @focus="select_focus = 0"
                                :remote-method="filterMethod"
                                v-model="submit_data.bank_code"
                                placeholder="请选择银行"
                                @visible-change="bank"
                                @change="bankChange"
                                clearable
                                style="width: 260px; margin-right: 20px"
                            >
                                <el-option
                                    v-for="item in options_bank_code"
                                    :key="item.bank_code"
                                    :label="item.name"
                                    :value="item.bank_code"
                                >
                                </el-option>

                                <el-pagination
                                    @size-change="handleSizeChange($event, 'bank')"
                                    @current-change="handleCurrentChange($event, 'bank')"
                                    :current-page="bank_options_data.page"
                                    :page-sizes="[10, 20, 30, 40]"
                                    :page-size="bank_options_data.limit"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="bankTotal"
                                >
                                </el-pagination>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="支行银行号:">
                            <el-select
                                filterable
                                remote
                                @focus="select_focus = 1"
                                :remote-method="filterMethod"
                                v-model="submit_data.branch_code"
                                placeholder="请选择银行"
                                @visible-change="branchBank"
                                @change="branchChange"
                                clearable
                                style="width: 260px; margin-right: 20px"
                            >
                                <el-option
                                    v-for="item in options_branch_code"
                                    :key="item.branch_code"
                                    :label="item.branch_name"
                                    :value="item.branch_code"
                                >
                                </el-option>
                                <el-pagination
                                    @size-change="handleSizeChange($event, 'branch')"
                                    @current-change="handleCurrentChange($event, 'branch')"
                                    :current-page="branch_options_data.page"
                                    :page-sizes="[10, 20, 30, 40]"
                                    :page-size="branch_options_data.limit"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="branchTotal"
                                >
                                </el-pagination>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="持卡人证件类型:">
                            <el-select
                                v-model="submit_data.cert_type"
                                :placeholder="submit_rules.cert_type.placeholder"
                                style="width: 260px; margin-right: 20px"
                                clearable
                            >
                                <el-option label="身份证" value="00"> </el-option>
                                <el-option label="护照" value="01"> </el-option>
                                <el-option label="军官证" value="02"> </el-option>
                                <el-option label="其他" value="07"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="持卡人证件号码:">
                            <el-input
                                v-model="submit_data.cert_no"
                                :placeholder="submit_rules.cert_no.placeholder"
                                style="width: 260px; margin-right: 5px"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="持卡人证件有效期类型:">
                            <el-select
                                v-model="submit_data.cert_validity_type"
                                :placeholder="submit_rules.cert_validity_type.placeholder"
                                style="width: 260px; margin-right: 20px"
                                clearable
                            >
                                <el-option label="长期有效" value="1"> </el-option>
                                <el-option label="非长期有效" value="0"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="持卡人证件有效期（起始）:">
                            <el-date-picker
                                format="yyyy-MM-dd"
                                value-format="yyyyMMdd"
                                v-model="submit_data.cert_begin_date"
                                type="date"
                                style="width: 260px; margin-right: 20px"
                                :placeholder="submit_rules.cert_begin_date.placeholder"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="持卡人证件有效期（截止）:">
                            <el-date-picker
                                format="yyyy-MM-dd"
                                value-format="yyyyMMdd"
                                v-model="submit_data.cert_end_date"
                                type="date"
                                style="width: 260px; margin-right: 20px"
                                :placeholder="submit_rules.cert_end_date.placeholder"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <!-- 对话框底部按钮 -->
            <div style="display: flex; justify-content: center; margin-top: 20px">
                <submitBtn
                    @onSubmitDig="onSubmitDig"
                    :data="submit_data"
                    :rules="submit_rules"
                    :url="submit_url"
                    :JSON_Boolean="false"
                ></submitBtn>
                <el-button @click="closeDialog">关闭</el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script>
var _this;

export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newDate, oldData) {
            _this.show = true;
            // _this.bank();
        }
    },
    data() {
        return {
            show: false,

            select_focus: '',

            bankTotal: 0,
            branchTotal: 0,
            submit_url: '/huifu/open',
            regProvIdArray: [], // 省数组
            regAreaIdArray: [], // 市数组
            // regDistrictIdArray: [], // 区域数组
            adcode: '',
            options_bank_code: [],
            options_branch_code: [],

            bank_options_data: {
                page: 1,
                limit: 10,
                name: ''
            },
            branch_options_data: {
                page: 1,
                limit: 10,
                bank_code: '',
                branch_name: ''
            },

            // 表单数据
            submit_data: {
                name: '',
                card_no: '',

                prov_id: '',
                area_id: '',
                bank_code: '',
                branch_code: '',
                cert_type: '',
                cert_no: '',
                cert_validity_type: '',
                cert_begin_date: '',
                cert_end_date: ''
            },
            submit_rules: {
                name: {
                    placeholder: '银行卡户名',
                    rules: {
                        required: true,
                        message: '银行卡户名错误',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },

                card_no: {
                    placeholder: '银行卡号',
                    rules: {
                        required: true,
                        message: '银行卡号错误',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                prov_id: {
                    placeholder: '银行所在省',
                    rules: {
                        required: true,
                        message: '银行所在省未选择',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                area_id: {
                    placeholder: '银行所在市',
                    rules: {
                        required: true,
                        message: '银行所在市错误',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                bank_code: {
                    placeholder: '银行号',
                    rules: {
                        required: true,
                        message: '银行号',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                branch_code: {
                    placeholder: '支行银行号',
                    rules: {
                        required: true,
                        message: '支行银行号',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                cert_type: {
                    placeholder: '持卡人证件类型',
                    rules: {
                        required: true,
                        message: '持卡人证件类型',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                cert_no: {
                    placeholder: '持卡人证件号码',
                    rules: {
                        required: true,
                        message: '持卡人证件号码',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                cert_validity_type: {
                    placeholder: '持卡人证件有效期类型',
                    rules: {
                        required: true,
                        message: '持卡人证件有效期类型',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                cert_begin_date: {
                    placeholder: '持卡人证件有效期（起始）',
                    rules: {
                        required: true,
                        message: '持卡人证件有效期（起始）不能为空',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                cert_end_date: {
                    placeholder: '持卡人证件有效期（截止）',
                    rules: {
                        required: false,
                        message: '持卡人证件有效期（截止）不能为空',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },

    methods: {
        filterMethod(query, e) {
            console.log(query, 'query');

            console.log(_this.select_focus, '_this.select_focus');
            if (_this.select_focus == '0') {
                _this.bank_options_data.name = query;
                _this.bank_options_data.page = 1;

                _this.bank(true);
            } else {
                console.log(query, 'else');
                _this.branch_options_data.branch_name = query;

                _this.branch_options_data.page = 1;
                console.log(_this.branch_options_data, '_this.branch_options_data    ');
                _this.branchBank(true);
            }
            // const selectRef = this.$refs[`select${query.charAt(0)}`];
            // console.log(selectRef,'selectRef');

            //  _this.bank_options_data.name = query;
            //     _this.bank_options_data.page = 1;

            //     _this.bank();

            // if (e == 'bank') {
            //     _this.bank_options_data.name = query;
            //     _this.bank_options_data.page = 1;

            //     _this.bank();
            // } else {
            //     _this.branch_options_data.branch_name = query;
            //     _this.branch_options_data.page = 1;
            //     _this.branchBank();
            // }
        },
        bank(val) {
            _this.options_bank_code = [];
            if (val) {
                _this
                    .$post('/huifu/bank', _this.bank_options_data)
                    .then((res) => {
                        _this.options_bank_code = res.data;
                        _this.bankTotal = Number(res.count);
                    })
                    .catch((err) => {});
            }
        },
        branchBank(val) {
            console.log(_this.submit_data.bank_code, '_this.submit_data.bank_code');

            _this.options_branch_code = [];

           if(val){
             if (_this.submit_data.bank_code == '') {
                this.$message.error('请先选择银行号');
                return;
            }
             _this
                .$post('/huifu/branchBank', _this.branch_options_data)
                .then((res) => {
                    _this.options_branch_code = res.data;
                    _this.branchTotal = Number(res.count);
                })
                .catch((err) => {});
           }

            // _this
            //     .$post('/huifu/branchBank', _this.branch_options_data)
            //     .then((res) => {
            //         _this.options_branch_code = res.data;
            //         _this.branchTotal = Number(res.count);
            //     })
            //     .catch((err) => {});
        },
        branchChange() {
            _this.branch_options_data.branch_name = ''; // 选择支行银行号以后清空查询条件的银行名称，防止再次点击保留上次查询的名字而导致只能查询到上次的数据
        },
        bankChange(val) {
            // 选择银行号
            _this.branch_options_data.bank_code = val;
            // 如果重新选择银行号，清空上一次填写的支行银行号
            _this.submit_data.branch_code = '';

            // if (val !== null && val !== '') {
            //     _this.branchBank(true);
            // }

            _this.bank_options_data.name = ''; // 选择银行号以后清空查询条件的银行名称，防止再次点击保留上次查询的名字而导致只能查询到上次的数据
        },
        handleSizeChange(val, e) {
            // e = bank 银行号; e = branch 支行银行号
            if (e == 'bank') {
                _this.bank_options_data.limit = val;
                _this.bank(true);
            } else {
                _this.branch_options_data.limit = val;
                _this.branchBank(true);
            }

            //初始化列表
        },
        handleCurrentChange(val, e) {
            // e = bank 银行号; e = branch 支行银行号

            if (e == 'bank') {
                _this.bank_options_data.page = val;
                console.log(_this.submit_data.bank_code, 'submit_data.bank_code');
                _this.bank(true);
            } else {
                _this.branch_options_data.page = val;
                _this.branchBank(true);
            }
        },

        // 获取省
        getDistrict(val) {
            if (val == 'sheng') {
                _this.regProvIdArray = [];
                _this.adcode = '';
            }
            if (val == 'shi') {
                _this.regAreaIdArray = [];
                if (_this.submit_data.prov_id == '') {
                    this.$message.error('请先选择省');
                    return;
                }
                _this.adcode = _this.submit_data.prov_id;
            }
            // if (val == 'qu') {
            //     _this.regDistrictIdArray = [];
            //     if (_this.submit_data.regAreaId == '') {
            //         this.$message.error('请先选择市');
            //         return;
            //     }
            //     _this.adcode = _this.submit_data.regAreaId;
            // }

            // var opts = {
            //     subdistrict: 1, //返回下一级行政区
            //     showbiz: false //最后一级返回街道信息
            // };

            var district = new TMap.service.District(); //注意：需要使用插件同步下发功能才能这样直接使用
            console.log(_this.adcode, '_this.adcode');
            district.getChildren({ id: _this.adcode }).then((result) => {
                console.log(result);
                if (result.status == 0) {
                    let districtListArr = result.result[0];
                    for (let i = 0; i < districtListArr.length; i++) {
                        if (val == 'sheng') {
                            _this.regProvIdArray.push({ name: districtListArr[i].fullname, adcode: districtListArr[i].id });
                        }
                        if (val == 'shi') {
                            _this.regAreaIdArray.push({ name: districtListArr[i].fullname, adcode: districtListArr[i].id });
                        }
                        // if (val == 'qu') {
                        //     _this.regDistrictIdArray.push({name:districtListArr[i].name,adcode:districtListArr[i].adcode});
                        // }
                    }
                }
            });
        },

        // 提交
        onSubmitDig() {
            _this.$emit('onSubmit');
            _this.closeDialog();
        },
        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.select_focus = '';
            _this.bankTotal = 0;
            _this.branchTotal = 0;

            _this.regProvIdArray = [];
            _this.regAreaIdArray = [];
            // _this.regDistrictIdArray = [];
            _this.adcode = '';

            _this.options_bank_code = [];
            _this.options_branch_code = [];
            _this.bank_options_data = {
                page: 1,
                limit: 10,
                name: ''
            };
            _this.branch_options_data = {
                page: 1,
                limit: 10,
                bank_code: '',
                branch_name: ''
            };

            _this.submit_data = {
                name: '',
                card_no: '',

                prov_id: '',
                area_id: '',
                bank_code: '',
                branch_code: '',
                cert_type: '',
                cert_no: '',
                cert_validity_type: '',
                cert_begin_date: '',
                cert_end_date: ''
            };
        }
    }
};
</script>
<style scoped>
.recharge-btn {
    display: flex;
}
.form-box {
    padding: 20px;
    box-sizing: border-box;
    width: 100%;
}

.recharge-span {
    font-size: 18px;
    margin: 10px 0;
}
</style>
<style>
.recharge-btn .el-button--info {
    border: 1px solid #05c0ab;
    background-color: #fff;
    color: #05c0ab;
}
.form-box .el-image__inner {
    width: 260px;
}
</style>

